export const Goal = 'Goal';
export const OwnGoal = 'OwnGoal';
export const RedCard = 'RedCard';


/** WEBPACK FOOTER **
 ** ./src/constants/SummaryEventTypes.js
 **/